import StringToSelect from "@/components/ui/StringToSelect";
import React from "react";

import HamburgerSVG from "@/components/ui/SVGIcons/HamburgerSVG";
import TrashSVG from "@/components/ui/SVGIcons/TrashSVG";
import { minLengthRegex } from "@mltask/core/Utils/RegexHelper";
import dynamic from "next/dynamic";
import { useFormContext } from "react-hook-form";
import { RiInputCursorMove } from "react-icons/ri";
const SimpleTextInput = dynamic(
  () => import("@/components/ui/Input/SimpleTextInput"),
  {
    ssr: false,
  }
);
export enum ChunkType {
  PRESET_TEXT,
  USER_INPUT,
}

export type InputChunk = { type: ChunkType };
export type UserInputChunk = InputChunk & {
  displayName: string;
  description: string;
};
export type PresetInputChunk = InputChunk & {
  text: string;
};

type Props = {
  inputName: string;
  chunkIndex: number;
  inputChunk: InputChunk;
  forbiddenDisplayNames: string[];
  onPasteLargeText: (text: string) => void;
  onItemChanged: (old: InputChunk, newData: InputChunk) => void;
  onItemDelete: (item: InputChunk) => void;
};

export default function InputPresetChunkUI({
  inputName,
  chunkIndex,
  inputChunk,
  forbiddenDisplayNames,
  onPasteLargeText,
  onItemChanged,
  onItemDelete,
}: Props) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  function renderInputChunk() {
    if (inputChunk.type == ChunkType.USER_INPUT) {
      return renderUserInputChunk(inputChunk as UserInputChunk);
    }
    if (inputChunk.type == ChunkType.PRESET_TEXT) {
      return renderPresetInputChunk(inputChunk as PresetInputChunk);
    }
  }
  function renderPresetInputChunk(chunk: PresetInputChunk) {
    return (
      <div className="flex flex-col space-y-2">
        <StringToSelect
          description={undefined}
          currentIdentifier={"Preset Input"}
          options={["User Input", "Preset Input"].map((x) => ({
            displayValue: x,
            identifier: x,
          }))}
          onSelectionChange={(taskSelection) => {
            console.log("taskSelection = " + taskSelection);
            if (taskSelection == "User Input") {
              onItemChanged(chunk, { type: ChunkType.USER_INPUT });
            }
          }}
        />
        <div className="text-base-100">
          <SimpleTextInput
            titleTWClass="text-base-content font-bold"
            onPaste={(pastedText) => {
              onPasteLargeText(pastedText);
            }}
            registrar={register(`${inputName}_${chunkIndex}`, {
              required: true,
              pattern: minLengthRegex(1),
              onChange: (e) => {
                const newText = e.target.value;
                onItemChanged(chunk, {
                  ...chunk,
                  text: newText,
                } as PresetInputChunk);
              },
            })}
            errorSection={
              errors[`${inputName}_${chunkIndex}`] && (
                <div className="mt-5 flex items-center rounded-md bg-secondary-content p-2">
                  <span className="text-error">Cannot be an empty string</span>
                </div>
              )
            }
            // onChange={(newText) => {
            //   // console.log("NEW TEXT = " + newText);

            // }}
            inputType="text"
            placeholder="Preset Chunk"
            value={chunk.text}
            pathD="M18 17h-7.5l2-2H18M6 17v-2.5l7.88-7.85c.19-.2.51-.2.71 0l1.76 1.76c.2.2.2.51 0 .71L8.47 17M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"
          />
        </div>

        {/* <input
          type="text"
          value={chunk.text}
          onChange={(event) => {
            onItemChanged(chunk, {
              ...chunk,
              text: event.target.value,
            } as PresetInputChunk);
          }}
          placeholder="preset chunk"
          className="input-bordered input w-full"
        /> */}
      </div>
    );
  }
  function renderUserInputChunk(chunk: UserInputChunk) {
    return (
      <div className="flex flex-col space-y-2">
        <StringToSelect
          description={undefined}
          currentIdentifier={"User Input"}
          options={["User Input", "Preset Input"].map((x) => ({
            displayValue: x,
            identifier: x,
          }))}
          onSelectionChange={(taskSelection) => {
            console.log("taskSelection = " + taskSelection);
            if (taskSelection == "Preset Input") {
              onItemChanged(chunk, { type: ChunkType.PRESET_TEXT });
            }
          }}
        />

        <div className="text-base-100">
          <SimpleTextInput
            titleTWClass="text-base-content font-bold"
            registrar={register(`${inputName}_${chunkIndex}`, {
              required: true,
              pattern: minLengthRegex(1),
              onChange: (e) => {
                // setPresetName(e.target.value);
                const newText = e.target.value;
                var newVal = newText;
                const found = forbiddenDisplayNames.find((x) => x == newVal);
                if (found) {
                  //this is to make sure no 2 user input templates have the same name
                  newVal += "*";
                }
                onItemChanged(chunk, {
                  ...chunk,
                  displayName: newVal,
                } as UserInputChunk);
              },
            })}
            errorSection={
              errors[`${inputName}_${chunkIndex}`] && (
                <div className="mt-5 flex items-center rounded-md bg-secondary-content p-2">
                  <span className="text-error">Cannot be an empty string</span>
                </div>
              )
            }
            // onChange={(newText) => {

            // }}
            SVGELement={<RiInputCursorMove />}
            inputType="text"
            placeholder="Parameter Name"
            value={chunk.displayName}
          />
        </div>

        <div className="text-base-100">
          <SimpleTextInput
            titleTWClass="text-base-content font-bold"
            // registrar={register("presetName", {
            //   required: true,
            //   pattern: Constants.minLengthRegex(3),
            //   onChange: (e) => {
            //     setPresetName(e.target.value);
            //   },
            // })}
            // errorSection={
            //   errors["presetName"] && (
            //     <div className="mt-5 flex items-center rounded-md bg-secondary-content p-2">
            //       <span className="text-error">
            //         Invalid Name Length (Min 3)
            //       </span>
            //     </div>
            //   )
            // }
            onChange={(newText) => {
              var newVal = newText;
              onItemChanged(chunk, {
                ...chunk,
                description: newVal,
              } as UserInputChunk);
            }}
            inputType="text"
            placeholder="Description"
            value={chunk.description}
            pathD="M18 17h-7.5l2-2H18M6 17v-2.5l7.88-7.85c.19-.2.51-.2.71 0l1.76 1.76c.2.2.2.51 0 .71L8.47 17M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"
          />
        </div>
      </div>
    );
  }
  function renderHeader() {
    return (
      <div className="flex flex-row justify-between">
        <HamburgerSVG />
        <div className="relative -right-4 -top-4 ">
          <button
            type="button"
            className="btn btn-square btn-error btn-xs text-white"
            onClick={() => {
              onItemDelete(inputChunk);
            }}
          >
            <TrashSVG />
          </button>
        </div>
      </div>
    );
  }
  return (
    <div>
      {renderHeader()}
      {renderInputChunk()}
    </div>
  );
}
